import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { updateAnalysisPeriscope } from '../../redux/application/actions';
import { useAction } from '@hooks/useAction';
import { useCallback } from 'react';
import { useSonarSelector } from '@hooks/useSonarSelector';

export interface UseAnalysisPericopeResult {
	open: (sonarObjectId: number, type: SonarObjectType) => void;
}

export function useAnalysisPeriscope() {
	const hasAnalysisCard = useSonarSelector((state) => Boolean(state.application.periscope.analysisTarget));

	const updateTarget = useAction(updateAnalysisPeriscope);

	const open = useCallback((sonarObjectId: number, type: SonarObjectType) => {
		if (hasAnalysisCard) {
			return;
		}

		updateTarget({
			id: sonarObjectId,
			name: '',
			type
		});
	}, [ hasAnalysisCard, updateTarget ]);

	return { open };
}
